import { Search, X } from "lucide-react";
import { PRIORITIES } from "../lib/helpers";

export const FilterBar = ({ q, setQ, fPriority, setFPriority, fAssignee, setFAssignee, users }) => {
  const hasFilters = q || fPriority || fAssignee;
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative">
        <Search className="h-4 w-4 text-zinc-500 absolute left-3 top-1/2 -translate-y-1/2" />
        <input data-testid="task-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar tareas…"
          className="bg-[#121214] border border-white/10 rounded-lg pl-9 pr-3 py-2 text-sm outline-none focus:border-primary w-44 lg:w-64" />
      </div>
      <select data-testid="filter-priority" value={fPriority} onChange={(e) => setFPriority(e.target.value)}
        className="bg-[#121214] border border-white/10 rounded-lg px-2.5 py-2 text-sm outline-none focus:border-primary text-zinc-300">
        <option value="">Prioridad: todas</option>
        {Object.entries(PRIORITIES).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
      </select>
      <select data-testid="filter-assignee" value={fAssignee} onChange={(e) => setFAssignee(e.target.value)}
        className="bg-[#121214] border border-white/10 rounded-lg px-2.5 py-2 text-sm outline-none focus:border-primary text-zinc-300 max-w-[180px]">
        <option value="">Responsable: todos</option>
        {users.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
      </select>
      {hasFilters && (
        <button data-testid="clear-filters" onClick={() => { setQ(""); setFPriority(""); setFAssignee(""); }}
          className="text-xs text-zinc-500 hover:text-white flex items-center gap-1 px-2 py-1 transition-colors">
          <X className="h-3.5 w-3.5" /> Limpiar
        </button>
      )}
    </div>
  );
};
